import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Follow_up_payment_receipt } from '../../models/follow_up_payment_receipt';

@Component({
  standalone: false,
  selector: 'app-modal-payment-receipt',
  templateUrl: './modal-payment-receipt.component.html',
styleUrls:  ['./modal-payment-receipt.component.css']
})
export class ModalPaymentReceiptComponent implements OnInit {

	receipt: Follow_up_payment_receipt = new Follow_up_payment_receipt({});

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

}
